import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';
document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');
let nav_box = document.querySelector('.hd_nav_box');

if (button && nav_box) {
  button.addEventListener('click', function() {

    if (nav_box.classList.contains('is_open')) {
      nav_box.classList.remove("is_open");
      button.classList.remove("is_close");
    } else {
      nav_box.classList.add("is_open");
      button.classList.add("is_close");
    }

  });
}

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

/*----------------------------------------
index work スライダー
------------------------------------------*/
const mySwiper = new Swiper('.swiper', {
  loop: true,
  autoplay: false,
  centeredSlides: true,

  // 1024px以下の設定
  slidesPerView: 1.2,
  spaceBetween: 20, // ここでスライド間の溝（マージン）を作る

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  breakpoints: {
    // 1025px以上の設定
    1025: {
      slidesPerView: 3.5,
      spaceBetween: 30,
      centeredSlides: false,
    }
  }
});

/*------------------------------------------------
タブ切り替え
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const tabItems = document.querySelectorAll(".tab-btn");
  const tabPanels = document.querySelectorAll(".tab-panel");

  // --- タブ切り替え関数 ---
  const switchTab = (index) => {
    if (index === -1 || !tabItems[index]) return;

    tabItems.forEach(t => t.classList.remove("active"));
    tabPanels.forEach(p => p.classList.remove("active"));

    tabItems[index].classList.add("active");
    if (tabPanels[index]) {
      tabPanels[index].classList.add("active");
    }
  };

  // --- 1. 初期表示時のタブ判定 ---
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  let initialIndex = 0;

  // URLパラメータ ?tab=N を優先、次に #tabN をチェック
  if (urlParams.has('tab')) {
    initialIndex = parseInt(urlParams.get('tab'), 10);
  } else if (hash.startsWith("#tab")) {
    const tabNum = parseInt(hash.replace("#tab", ""), 10);
    if (!isNaN(tabNum)) initialIndex = tabNum;
  }

  switchTab(initialIndex);

  // --- 2. ページ読み込み完了後のスクロール処理 ---
  // タブ切り替えで高さが変わるため、完全に読み込んでから移動させる
  window.addEventListener("load", () => {
    if (window.location.hash === "#main") {
      const target = document.getElementById("main");
      if (target) {
        // 少し遅らせて確実に位置を計算（ブラウザの自動スクロールとの競合回避）
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  });

  // --- 3. クリックイベントの制御 ---
  tabItems.forEach((tabItem, index) => {
    tabItem.addEventListener("click", (e) => {
      const href = tabItem.getAttribute("href") || "";

      // ページ遷移を伴う（?を含む）またはページ内移動（#main）の場合は
      // JSで動作を止めずに、ブラウザの標準遷移に任せる
      if (href.includes("?") || href.includes("#main")) {
        // 何もしない（＝リンクが機能する）
        return;
      }

      // 同一ページ内での単純なタブ切り替えのみ JS で実行
      e.preventDefault();
      switchTab(index);
    });
  });
});

/*----------------------------------------
  URLパスに基づいた active クラス付与（アーカイブ・固定ページ用）
------------------------------------------*/
window.addEventListener('DOMContentLoaded', () => {
  const currentPath = window.location.pathname.replace(/\/$/, "");
  const tabs = document.querySelectorAll('.tab-btn');
  let hasActive = false;

  tabs.forEach(tab => {
    try {
      const tabUrl = new URL(tab.href, window.location.origin);
      const tabPath = tabUrl.pathname.replace(/\/$/, "");

      if (tabPath !== "" && currentPath.includes(tabPath)) {
        tab.classList.add('active');
        if (currentPath.includes('/category/')) {
          tab.classList.add('archive');
        }
        hasActive = true;
      }
    } catch (e) {}
  });

  // 「すべて」ボタンの調整
  const allBtn = document.querySelector('.tab-btn[href*="/works"]');
  if (allBtn) {
    const otherActive = Array.from(tabs).some(tab => tab !== allBtn && tab.classList.contains('active'));
    if (otherActive) {
      allBtn.classList.remove('active');
    } else {
      allBtn.classList.add('active');
    }
  }
});

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});


// /*----------------------------------------
// お問い合わせバリデーション
// ------------------------------------------*/
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}

/*----------------------------------------
要素アニメーション
------------------------------------------*/
const item = document.querySelectorAll('.scrollAnim');
item.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 90%",
    onEnter: () => target.classList.add('active'), // その要素自身にクラスを付ける
  });
});

/*----------------------------------------
indexトップスライドショー
------------------------------------------*/
let sliderAnimations = []; // 実行中のアニメーションを保持する配列

function initLoopSlider() {
  const sliderWraps = document.querySelectorAll('.loopSlider .loopslider_wrap');
  const isMobile = window.innerWidth <= 1024;

  // 既存のアニメーションがあれば全て停止してクリア
  sliderAnimations.forEach(anim => anim.cancel());
  sliderAnimations = [];

  sliderWraps.forEach(sliderWrap => {
    const ul = sliderWrap.querySelector('ul');
    if (!ul) return;

    // クローンが未作成の場合のみ作成（3つにする）
    if (sliderWrap.querySelectorAll('ul').length < 3) {
      const clone1 = ul.cloneNode(true);
      const clone2 = ul.cloneNode(true);
      sliderWrap.appendChild(clone1);
      sliderWrap.insertBefore(clone2, ul);
    }

    const targetUl = sliderWrap.querySelectorAll('ul')[1]; // 真ん中の要素を基準にする
    let animationOptions = {};
    let keyframes = [];

    if (isMobile) {
      // --- 1024px以下：左から右（横スクロール） ---
      const singleWidth = targetUl.offsetWidth;
      sliderWrap.style.width = `${singleWidth * 3}px`;
      sliderWrap.style.display = 'flex'; // 横並びにする
      sliderWrap.style.flexDirection = 'row';

      keyframes = [
        { transform: `translateX(-${singleWidth}px)` },
        { transform: 'translateX(0)' }
      ];
    } else {
      // --- 1024px超：下から上（縦スクロール） ---
      const singleHeight = targetUl.offsetHeight;
      sliderWrap.style.width = 'auto';
      sliderWrap.style.display = 'block'; // 縦並びに戻す
      sliderWrap.style.flexDirection = 'column';

      keyframes = [
        { transform: 'translateY(0)' },
        { transform: `translateY(-${singleHeight}px)` }
      ];
    }

    // アニメーション実行
    const anim = sliderWrap.animate(keyframes, {
      duration: 30000,
      iterations: Infinity,
      easing: 'linear'
    });

    sliderAnimations.push(anim);
  });
}

// イベント登録
window.addEventListener('load', initLoopSlider);

// リサイズ時は負荷軽減のため少し待ってから実行（デバウンス処理）
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initLoopSlider, 200);
});

window.addEventListener('load', function() {
  if (body.classList.contains("home")) {
    gsap.registerPlugin(ScrollTrigger);

    // 1. 初めにJSでヘッダーを画面外に飛ばしておく
    gsap.set('#header', { y: '-100%' });

    /* OPENING ANIMATION PATTERN01 */
    const openingTL = gsap.timeline({
        delay: .2,
        // 1回だけ発動させる（リロードしない限り再発動しない）
    });

    openingTL
    .fromTo('#mv_title', { autoAlpha: 0, scale: 1.1 }, { autoAlpha: 1, scale: 1 })
    .fromTo('#mv_text', { autoAlpha: 0, scale: 1.2 }, { autoAlpha: 1, scale: 1 })
    .to('#header', { y: '0%', duration: 0.6, ease: 'power2.out' });
  }
});

gsap.registerPlugin(ScrollToPlugin);
/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const headerHeight = header ? header.offsetHeight : 0;

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: headerHeight  // ← headerの高さを使う
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});


/*----------------------------------------
施工事例　カテゴリーボタン
------------------------------------------*/
window.addEventListener('load', () => {
  // 現在のURLを取得し、ハッシュとクエリを除去
  let currentUrlClean = window.location.href.split('#')[0].split('?')[0];
  currentUrlClean = currentUrlClean.split('/page/')[0];

  const buttons = document.querySelectorAll('.cate-btn');

  buttons.forEach(btn => {
    btn.classList.remove('active');

    // ボタンのURLも同様にクリーンアップ
    let btnUrlClean = btn.href.split('#')[0].split('?')[0].split('/page/')[0];

    // 末尾のスラッシュを無視して比較
    if (currentUrlClean.replace(/\/$/, "") === btnUrlClean.replace(/\/$/, "")) {
      btn.classList.add('active');
    }
  });
});


// GSAPの日本語IDエラーを黙らせるガード
(function() {
    const originalQuerySelectorAll = document.querySelectorAll;
    document.querySelectorAll = function(selector) {
        try { return originalQuerySelectorAll.apply(document, arguments); }
        catch (e) { if (typeof selector === 'string' && selector.includes('%')) return []; throw e; }
    };
})();

// 1. スクロール復元を無効化
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

document.addEventListener('DOMContentLoaded', () => {
    const updateTabs = (isInitial = false) => {
        // ハッシュを取得してデコード（日本語対応）
        let rawHash = decodeURIComponent(window.location.hash);
        const buttons = document.querySelectorAll('.service-btn');
        const panels = document.querySelectorAll('.service-items');

        // ハッシュがない、または空の場合はデフォルトを設定
        if (!rawHash || rawHash === "#") {
            rawHash = "#内外装工事";
        }

        const targetId = rawHash.replace('#', '');
        const targetPanel = document.getElementById(targetId);

        // 重要：ターゲットが存在するかチェック
        if (targetPanel) {
            // A. ボタンのactive管理
            buttons.forEach(btn => {
                btn.classList.remove('active');
                // hrefの最後が #ハッシュ名 で終わるか判定
                const btnHref = decodeURIComponent(btn.getAttribute('href'));
                if (btnHref.endsWith(rawHash)) {
                    btn.classList.add('active');
                }
            });

            // B. パネルの切り替え
            panels.forEach(p => p.classList.remove('is-active'));
            targetPanel.classList.add('is-active');

            // C. スクロール処理
            if (isInitial) {
                // 初回はトップへ（少し遅らせる）
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 10);
            } else {
                // タブ切り替え時：少し待ってから位置を計算（表示確定後）
                setTimeout(() => {
                    const offset = 100;
                    const rect = targetPanel.getBoundingClientRect();
                    const targetPos = rect.top + window.pageYOffset - offset;

                    window.scrollTo({
                        top: targetPos,
                        behavior: 'smooth'
                    });
                }, 50); // display:blockが反映される微小な待ち時間
            }
        } else {
            // ターゲットが見つからない場合のエラー回避
            console.warn(`Target ID "${targetId}" not found.`);
        }
    };

    // 初期実行
    updateTabs(true);
    window.addEventListener('hashchange', () => updateTabs(false));
});